import { useEffect } from "react";
import { CRM } from "@/components/atomic-crm/root/CRM";
import {
  dataProvider as fakeDataProvider,
  authProvider as fakeAuthProvider,
} from "@/components/atomic-crm/providers/fakerest";

const useFakeRest = import.meta.env.VITE_USE_FAKEREST === "true";

/**
 * Ponto de entrada da aplicação CRM DOTUS
 * Conectado ao banco de dados Supabase na nuvem.
 * Para usar o mock em memória, defina VITE_USE_FAKEREST=true.
 */
const App = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const p = window.location.pathname;
      if (
        p === "/set-password" ||
        p.startsWith("/set-password") ||
        p === "/login" ||
        p === "/sign-up" ||
        p === "/forgot-password" ||
        p === "/activate-crm" ||
        p.startsWith("/activate-crm") ||
        p === "/superadmin" ||
        p.startsWith("/superadmin")
      ) {
        const search = window.location.search || "";
        window.location.replace("/#" + p + search);
      }
    }
  }, []);

  return (
    <CRM
      {...(useFakeRest
        ? { dataProvider: fakeDataProvider, authProvider: fakeAuthProvider }
        : {})}
      title="Dotus CRM"
    />
  );
};

export default App;
